import { render } from "./InfoError.vue?vue&type=template&id=0d4aad75"
import script from "./InfoError.vue?vue&type=script&lang=js"
export * from "./InfoError.vue?vue&type=script&lang=js"

import "./InfoError.vue?vue&type=style&index=0&id=0d4aad75&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__